import * as React from 'react';
import { Query } from '@apollo/client/react/components';

import { TransactionQuery } from './queries';
import { InternalRefetchQueryDescriptor } from '@apollo/client';
import { Transaction } from './types';

type TransactionInfoContainerProps = {
  journalEntryId: string;
  children: (
    loading: boolean,
    error: string,
    transaction: Transaction,
    refetchQueries: InternalRefetchQueryDescriptor[],
  ) => React.ReactNode;
};

const TransactionInfoContainer = ({ journalEntryId, children }: TransactionInfoContainerProps) => (
  <Query query={TransactionQuery} variables={{ jeId: journalEntryId }}>
    {({ loading, error, data }: any) => {
      if (loading || error) {
        return null;
      }

      const transaction = data?.transaction;

      const refetchQueries = [{ query: TransactionQuery, variables: { jeId: journalEntryId } }];
      return <>{children(loading, error, transaction, refetchQueries)}</>;
    }}
  </Query>
);

export default TransactionInfoContainer;
